import { defineMessages } from "react-intl";

export default defineMessages({
  transferNotMade: {
    id: "serviceOfferOrderPreview.transferNotMade",
    defaultMessage: "Transfer not made",
  },
  transferErrorMessage: {
    id: "serviceOfferOrderPreview.transferErrorMessage",
    defaultMessage:
      "We are unable to pay the service provider because, unless we are mistaken, you have not yet made the payment of €{amountCents}. You can make this payment by bank transfer:",
  },
});
